import mixpanelClient from '@soluto-home-web/smart-home-support/api/mixpanelClient';
import { AnalyticsEventModel } from 'shisell';

import { IAnalyticsWriter } from './IAnalyticsWriter';

class MixpanelAnalyticsWriter implements IAnalyticsWriter {
  public async isEnabled(): Promise<boolean> {
    return Promise.resolve(true);
  }

  public async write(eventModel: AnalyticsEventModel): Promise<void> {
    const { Name, Identities, ExtraData } = eventModel;
    const distinct_id = Identities && Identities.UserBrowserId;
    await mixpanelClient.track(Name, { ...ExtraData, Identities, distinct_id });
  }
}

export default new MixpanelAnalyticsWriter();



// WEBPACK FOOTER //
// ./packages/web-app/src/services/analyticsWriters/MixpanelAnalyticsWriter.ts